<template>
	<li :class="deletedClass">
		<div class="user-image-container">
			<img
				v-if="result.photoURL"
				v-lazy="{ src: result.photoURL, error: this.noImage }"
				@click.prevent="goToUser(result)"
				class="user-image"
				alt="Profile picture"
			/>
			<div v-else class="user-image">
				<no-user-image
					:firstName="result.firstName"
					:lastName="result.lastName"
					:fontSize="13"
					:height="'35px'"
					:width="'35px'"
					@click.prevent="goToUser(result)"
				></no-user-image>
			</div>
		</div>
		<div class="user-details" @click.prevent="goToUser(result)">
			<p>{{result.firstName}} {{result.lastName}}</p>
			<p>@{{result.username}}</p>
		</div>
		<div
			v-if="$store.state.user.authUser !== null && $store.state.user.user.username !== '' && !result.deleted"
			class="follow-button"
		>
			<!-- removed  v-if="from !== 'blackBar'" -->
			<follow-button :user="result" :from="componentName"></follow-button>
		</div>
		<div v-if="result.deleted" class="deleted-note">
			<span class="stackng-note">
				User
				<br />deleted
			</span>
		</div>
	</li>
</template>

<script>
import FollowButton from "../users/userView/UserFollowButton.vue";
import NoUserImage from "../errors/NoUserImage.vue";
import { storyMixin } from "../../mixins/storyMixin";

export default {
	mixins: [storyMixin],
	data() {
		return {
			componentName: "resultCard",
			noImage:
				"https://icons-for-free.com/iconfiles/png/512/login+person+profile+user+users+icon-1320166527284195604.png"
		};
	},
	props: {
		result: {
			type: Object
		},
		from: {
			type: String,
			required: false
		}
	},
	components: {
		FollowButton,
		NoUserImage
	},
	methods: {
		goToUser(result) {
			this.$router.push({ path: `/s/${result.username}` });
		}
	},
	computed: {
		deletedClass() {
			if (this.result.deleted) {
				return "user-deleted";
			}
		}
	}
};
</script>

<style scoped>
li {
	position: relative;
	padding: 10px;
	background-color: #171717;
	border-radius: 10px;
	display: flex;
	height: fit-content;
	transition: all 0.3s ease;
	font-family: "Avenir", "Nunito", sans-serif;
}

li:hover {
	background-color: #423f3f;
	transform: translateY(-2px);
}

li div {
	display: inline-block;
	vertical-align: middle;
}

li div:first-child {
	/* width: 20%; */
	margin-right: 10px;
}

.user-deleted {
	/* background-color: #ff00002a; */
	pointer-events: none;
}

.user-deleted .user-details,
.user-deleted .user-image-container {
	opacity: 0.3;
}

.deleted-note {
	position: absolute;
	margin-right: 10px;
	right: 5px;
	top: 15px;
	text-align: center;
}

ion-icon[name="contact"] {
	font-size: 40px;
	color: #fff;
	vertical-align: middle;
	cursor: pointer;
}

.user-image {
	height: 35px;
	width: 35px;
	margin-right: 0px !important;
	border-radius: 50%;
	object-fit: cover;
	cursor: pointer;
	vertical-align: middle;
}

.user-details {
	cursor: pointer;
	width: 60%;
}

.follow-button {
	position: absolute;
	right: 0px;
}

p {
	font-size: 12px;
	color: #fff;
}

p:first-of-type {
	font-weight: 600;
}

p:last-of-type {
	color: #51c715;
}

@media only screen and (max-width: 768px) {
	ion-icon {
		font-size: 30px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/search/ResultCard.vue